import { toast } from 'react-toastify';
import _ from 'lodash';
import { translate } from 'core/utils';

class NotificationStore {
	constructor(rootStore) {
		this.rootStore = rootStore;
		this.messages = [];
	}

	load = loadingMessage => {
		const id = toast.loading(loadingMessage);
		return id;
	};

	dismiss = id => {
		toast.dismiss(id);
	};

	pull() {
		_.each(this.messages, messageProps => {
			toast(messageProps[0], messageProps[1]);
		});
		this.messages = [];
	}

	success(message, push = false) {
		if (!push) {
			toast.success(translate(message));
		} else {
			this.messages.push([translate(message), { type: toast.TYPE.SUCCESS }]);
		}
	}

	warning(message, push = false) {
		if (!push) {
			toast.warn(translate(message));
		} else {
			this.messages.push([translate(message), { type: toast.TYPE.WARNING }]);
		}
	}

	error(message, push = false) {
		if (!push) {
			toast.error(translate(message));
		} else {
			this.messages.push([translate(message), { type: toast.TYPE.ERROR }]);
		}
	}
}

export default NotificationStore;



// WEBPACK FOOTER //
// ./src/core/stores/NotificationStore.js